<template>
  <a
    href="#available-times"
    @click="selectDate"
    :class="{
      disabled: disabled,
      placeholder: date === undefined || day === '',
      selected: $store.state.selectedDate === date,
    }"
  >
    <span>{{ day }}</span>
  </a>
</template>

<script>
import axios from "axios";
export default {
  name: "Day",
  props: {
    date: String,
    day: String,
    disabled: Boolean,
  },
  methods: {
    selectDate() {
      this.$store.commit("setSelectedBooking", '');
      this.$store.commit("setSelectedDate", this.date);
      const params = new URLSearchParams();
      params.append("date", this.date);
      params.append("schedule", this.$store.state.selectedSchedule);
      axios
        .post(`${this.$store.state.API}/Bookings.php`, params)
        .then(this.onGetBookings);
    },    
    onGetBookings(response) {
      if (response.data.status == "ok") {
          this.$store.commit("setAvailableBookings", response.data['json-content']);             
      } else {
        this.$store.commit("setSelectedDate", "");
        alert("An error occurred getting the bookings");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  display: grid;
  place-items: center;  
  box-sizing: border-box;
  line-height: 1;
  letter-spacing: 0;
  text-align: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  user-select: none;
  text-decoration: none;
  font-family: inherit;
  font-size: 1.125rem;
  width: 30px;
  height: 30px;  
  @media (min-width: 415px) {
    width: 40px;
  height: 40px;
  }
  &.selected span {
    background: var(--blueGradient);
    color: var(--white);
    opacity: 1;
  }
  @media (hover: hover) {
    &:hover {
      span {
        background: var(--dark-blue);
      }
    }
  }
  span {
    transition: 0.2s all ease-in-out;
    width: 30px;
    height: 30px;
    @media (min-width: 415px) {
      width: 40px;
    height: 40px;
    }
    display: grid;
    place-items: center;        
    color: var(--white);
    background: var(--greyGradient);
    font-weight: 400;
    
  }
}
a:not(.disabled) span {
  border:1px solid var(--accent);
}
.placeholder {
  opacity: 0;
  pointer-events: none;
}
.disabled {  
  pointer-events: none;
  span {
   opacity: 0.2;
   background: #132540;
  }
}
</style>